import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import BusquedaPorIdentificador from "../../centroEquipos/components/BusquedaPorIdentificador";

export default function CentroEquipoDetalleDialog({
  open,
  onClose,
  tipo = "modem",
  identificador,
  title = "Detalle del equipo",
}) {
  const normalizedTipo = String(tipo || "modem").toLowerCase();
  const normalizedId = identificador == null ? "" : String(identificador).trim();
  const autoLoadKey = open && normalizedId ? `${normalizedTipo}-${normalizedId}` : "";

  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 1.25,
          maxHeight: "92vh",
        },
      }}
    >
      <DialogTitle sx={{ py: 1, fontSize: "0.95rem", fontWeight: 900 }}>
        {title}
        <Typography variant="caption" sx={{ display: "block", color: "text.secondary" }}>
          {normalizedTipo.toUpperCase()} - {normalizedId || "-"}
        </Typography>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 1, bgcolor: "#f8fafc" }}>
        {open && normalizedId ? (
          <BusquedaPorIdentificador
            key={autoLoadKey}
            initialTipo={normalizedTipo}
            initialBuscar={normalizedId}
            autoLoadKey={autoLoadKey}
            hideSearch
          />
        ) : (
          <Typography variant="body2" color="text.secondary">
            No hay identificador para consultar.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 0.75 }}>
        <Button size="small" onClick={onClose}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
